import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { images } from "../../config/images";
import { getHancoMachineStationDetails } from "../ProductionLine/services";

const HancoWashing = ({ setHancoWashing, batchId }) => {
  const [hancoWashingData, setHancoWashingData] = useState([]);

  useEffect(() => {
    handleGetHancoMachineData();
  }, [batchId]);

  const handleGetHancoMachineData = async () => {
    try {
      const resp = await getHancoMachineStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setHancoWashingData(resp.data.payload);
      }
    } catch (error) {
      setHancoWashingData([]);
      console.log("handlesubmit", error);
    }
  };
  return (
    <>
      <div className="modal-container" style={{ height: "40vh", top: "35vh" }}>
        <div className="modal-header">
          <div className="modal-title">HANCO WASHING PROCESS SHEET</div>
          <div
            onClick={() => setHancoWashing(false)}
            style={{ cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="modal-table-wrapper">
          <Table className="dipping-params">
            <TableHead>
              <TableRow>
                <TableCell>Max Temp (°C)</TableCell>
                <TableCell>Min Temp (°C)</TableCell>
                <TableCell>Time (Minutes)</TableCell>
                <TableCell>Water Level (Liters)</TableCell>
                <TableCell>Cycle Start Time</TableCell>
                <TableCell>Cycle End Time</TableCell>
                <TableCell>Operator</TableCell>
                <TableCell>Supervisor</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="gloves-report-body">
              {hancoWashingData?.map((e) => {
                return (
                  <TableRow>
                    <TableCell>{e.max_temp ? e.max_temp : ""}</TableCell>
                    <TableCell>{e.min_temp ? e.min_temp : ""}</TableCell>
                    <TableCell>
                      {e.time_minutes ? e.time_minutes : ""}
                    </TableCell>
                    <TableCell>{e.water_level ? e.water_level : ""}</TableCell>
                    <TableCell>
                      {e
                        ? e?.cycle_start_time
                          ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                          : "--"
                        : "--"}
                    </TableCell>
                    <TableCell>
                      {e
                        ? e?.cycle_end_time
                          ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                          : "--"
                        : "--"}
                    </TableCell>
                    <TableCell>{e.operator ? e.operator : "--"}</TableCell>
                    <TableCell>{e.supervisor ? e.supervisor : "--"}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
      <div
        className="modal-overlay"
        onClick={() => setHancoWashing(false)}
      ></div>
    </>
  );
};

export default HancoWashing;
